import { Box, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { Images } from "../../assets/common";
import "./index.scss";
import LinearBar from "../LinearBar";
import { useHistory } from "react-router";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import notifier from "../Notifier";
import { isOwner, kFormatter } from "../../constants/function";
import OutsideClickHandler from "react-outside-click-handler";
import ProfileMenu from "../ProfileMenu";
import { useTranslation } from "react-i18next";
import commonfr from "../../assets/common/resources/commonfr.svg"; // Importing your "case" asset

export default function NftCard({ nft }) {
  const { t } = useTranslation("common");
  const [show, setShow] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState(null);

  const history = useHistory();

  return (
    <Box className="_nft_card" sx={{ position: "relative" }}>
      {/* Adding the "case" on top of the card */}
      <Box className="_nft_card_case">
        <img
          src={commonfr}
          alt="case asset"
          className="_nft_case_image"
        />
      </Box>

      {/* Remaining content of the card */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        {!nft.platform ? null : nft.platform === "Hedera" ? (
          <img
            title={t("dropMenu.m23")}
            onClick={() => history.push(`/app/MyNft/${nft["nftId"]}`)}
            className="_network"
            src={Images.hbar_2}
            alt="nft"
          />
        ) : nft.platform === "Polygon" ? (
          <img
            title={t("dropMenu.m23")}
            onClick={() =>
              history.push(
                `/app/MyNft/${nft["nftId"] ? nft["nftId"] : nft["_id"]}`
              )
            }
            className="_network"
            src={Images.polygoon2}
            alt="polygon"
          />
        ) : nft.platform === "Siki" ? (
          <img
            title={t("dropMenu.m23")}
            onClick={() =>
              history.push(
                `/app/MyNft/${nft["nftId"] ? nft["nftId"] : nft["_id"]}`
              )
            }
            className="_network"
            src={Images.sikitoken}
            alt="siki"
          />
        ) : (
          <img
            title={t("dropMenu.m23")}
            onClick={() =>
              history.push(
                `/app/MyNft/${nft["nftId"] ? nft["nftId"] : nft["_id"]}`
              )
            }
            className="_network"
            src={Images.near_nft}
            alt="near"
          />
        )}
      </Box>

      <Box sx={{ position: "relative", zIndex: 1 }}>
        <MoreVertIcon
          color="default"
          className="_nft_hover"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedId(nft["nftId"]);
            setShow(true);
          }}
        />
        {show && nft["nftId"] === selectedId ? (
          <OutsideClickHandler onOutsideClick={() => setShow(false)}>
            <Box
              className="_nft_card_menu"
              onClick={() => {
                history.push(`/app/MyNft/${nft["nftId"]}`);
              }}
            >
              <Typography>{t("dropMenu.m23")}</Typography>
            </Box>
          </OutsideClickHandler>
        ) : null}
      </Box>

      <Box className="_record_container">
        <img
          className="_record"
          src={nft?.recordData?.recordImg}
          alt={nft?.recordData?.recordName}
        />
        <Stack
          className="_record_level"
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
        {[...Array(nft?.recordData?.level)].map((level, index) => {
          const dynamicWidth = `calc(48px - ${(nft?.recordData?.level - 1) * 5}px)`;
          return (
            <img
              key={index}
              className="_record_x"
              src={nft?.recordData?.recordImg}
              alt=""
              style={{ width: dynamicWidth }}  // Apply dynamic width inline
            />
          );
        })}
      </Stack>
      </Box>
      <Stack direction="column" sx={{ padding: "6px", zIndex: 1 }} spacing={1}>
        <Stack direction="row" justifyContent="space-between">
          <Typography className="fs-10 fade-text-60">
            {nft?.recordData?.lowerLimit}
          </Typography>
          <Typography className="fs-10 fade-text-60">
            {nft?.recordData?.nextRecordRequirement}{" "}
            {t("myCollection.nftCard.upperLimit")}
          </Typography>
        </Stack>
        <LinearBar
          value={`${nft?.recordData?.progress}%`}
          color="#FFEE20"
          noShadow={true}
        />
      </Stack>
      <Stack direction="row" className="_nft_data_box" sx={{ zIndex: 1 }}>
        <img
          className="nft_img"
          src={
            nft["thumbnailImg"]
              ? nft["thumbnailImg"]["filePath"]
              : nft["musicDetails"]
              ? nft["musicDetails"]["thumbnailImg"]["filePath"]
              : nft["music"]["thumbnailImg"]
              ? nft["music"]["thumbnailImg"]["filePath"]
              : Images.dummy
          }
          alt=""
        />
        <Stack direction="column" className="_nft_title">
          <Typography className="fs-13 ">
            {nft?.recordData?.recordName} {t("myCollection.nftCard.record")}
          </Typography>
          <Typography className="fs-12 ">
            {kFormatter(nft?.listens)}{" "}
            <span className="fs-10 fade-text-60">
              {t("myCollection.nftCard.stream")}
            </span>
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
